import React from 'react'
import PropTypes from 'prop-types'
import { withCookieConsent } from 'LiveBoard/hocs'
import ShareDialog from './ShareDialog'
import EmailDialog from './EmailDialog'
import { ShareButton } from './ShareButton'
import findKey from 'lodash/findKey'

const POPUP_DIMENSIONS = {
  width: 600,
  height: 450
}

class ShareBoard extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: false, displayEmailShareDialog: false }
  }

  handleOpen = () => {
    const {
      numberOfShareOptions, config, trackShareClick, onCookieConsent
    } = this.props

    if(numberOfShareOptions == 1) {
      const shareType = findKey(config)
      this.handleShareClick(shareType)
    } else {
      this.setState({ isOpen: true })
    }
    onCookieConsent()
    trackShareClick()
  }

  closeShareDialog = () => this.setState({ isOpen: false })
  closeEmailDialog = () => this.setState({ displayEmailShareDialog: false })

  handleShareClick = (type) => {
    if(type == 'email') {
      this.setState({ displayEmailShareDialog: true })
    } else {
      const specs = `height=${POPUP_DIMENSIONS.height},
        width=${POPUP_DIMENSIONS.width},
        top=${(screen.height - POPUP_DIMENSIONS.height)/2},
        left=${(screen.width - POPUP_DIMENSIONS.width)/2},
        screenY=${(screen.height - POPUP_DIMENSIONS.height)/2},
        screenX=${(screen.width - POPUP_DIMENSIONS.width)/2},
        toolbar=no,menubar=no,scrollbars=no,location=no`
      const url = `${this.props.shareUrls[type]}${encodeURIComponent(window.location.href)}`
      window.open(url, '', specs)
    }

    this.closeShareDialog()
  }

  handleEmailShareSubmit = (values) => {
    const { onEmailShare, config } = this.props
    onEmailShare(values, {invitationId: config.invitation_id})
    this.closeEmailDialog()
  }

  render() {
    const { themeColorHex, textColor, config, numberOfShareOptions } = this.props
    const { isOpen, displayEmailShareDialog } = this.state

    return numberOfShareOptions > 0 && (
      <section className="share-button-container">
        <ShareButton
          themeColorHex={themeColorHex}
          onClick={this.handleOpen} />
        { isOpen &&
          <ShareDialog
            config={config}
            onClose={this.closeShareDialog}
            onShareClick={this.handleShareClick} /> }
        { displayEmailShareDialog &&
          <EmailDialog
            themeColorHex={themeColorHex}
            onSubmit={this.handleEmailShareSubmit}
            onClose={this.closeEmailDialog} /> }
      </section>
    )
  }
}

ShareBoard.propTypes = {
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  trackShareClick: PropTypes.func.isRequired,
  onEmailShare: PropTypes.func.isRequired,
  shareUrls: PropTypes.object.isRequired,
  numberOfShareOptions: PropTypes.number.isRequired,
  onCookieConsent: PropTypes.func.isRequired
}

export default withCookieConsent(ShareBoard)
